export default "__VITE_ASSET__7d81bc67__"